import {FC} from 'react';
import {Box, Typography} from '@mui/material';
import {policyFrenchSx} from './PolicyFrench.sx';

export const PolicyFrench: FC = () => {
    return (
        <Box>
            <Box sx={policyFrenchSx.root}>
                <Typography variant="h2">Politique de confidentialité</Typography>

                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    AMP IT SA et les sociétés de son groupe (ci-après également individuellement ou collectivement
                    « <strong>AMP IT</strong> », « <strong>nous</strong> », « <strong>notre</strong> ») collectent et
                    traitent des données personnelles vous concernant et concernant d'autres personnes
                    (« <strong>tiers</strong> »). La présente politique de confidentialité (déclaration de protection
                    des données) peut être complétée séparément, par exemple dans des formulaires de consentement, des
                    conditions générales, des déclarations supplémentaires et autres moyens de communication.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Si vous nous communiquez des données ou si vous partagez avec nous des données concernant des tiers,
                    vous confirmez être autorisé à le faire et que les données concernées sont exactes. Vous êtes
                    également invité à vous assurer que les personnes dont les données sont partagées ont été informées
                    de cette politique de confidentialité.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Nous nous engageons à traiter les données à caractère personnel vous concernant de façon
                    responsable. En conséquence, nous nous conformons aux exigences de la Loi fédérale sur la protection
                    des données (LPD), de l’Ordonnance relative à la loi fédérale sur la protection des données (OLPD),
                    de la Loi sur les télécommunications (LTC) et aux autres dispositions de la législation suisse en
                    matière de protection des données. En ce qui concerne le traitement des données à caractère
                    personnel des personnes concernées résidant dans l’Union européenne, nous nous conformons également
                    aux dispositions du Règlement général européen de protection des données (RGPD).
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    1. Responsables du traitement
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    AMP IT SA, 1-3 Rue des Sablières, 1242 Satigny, Suisse est une société de droit suisse ayant
                    notamment pour but l’installation et la gestion des bornes de recharge pour les voitures électriques
                    ainsi que la création, le développement, l'exploitation et la gestion de tous logiciels, plateformes
                    ou portails informatiques sous toutes formes, sur tous les supports, en lien avec ses activités.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Elle est la "responsable du traitement" aux fins décrites ci-après, à moins qu’elle ne vous indique
                    le contraire dans un cas particulier, par exemple dans des politiques de confidentialité
                    spécifiques, sur un formulaire ou dans un contrat. Cela signifie que AMP IT SA est seule responsable
                    de la manière dont elle détient et utilise les données personnelles vous concernant.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Vous pouvez nous contacter pour des questions de protection des données et pour exercer vos droits
                    en vertu de la présente politique de confidentialité via l’adresse électronique suivante <a
                    href="mailto:info@amp-it.ch">info@amp-it.ch</a>
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    2. Champ d’application et objectif de la collecte, du traitement et de l’utilisation des données à
                    caractère personnel
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    2.1 Collecte et traitement des données personnelles
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Nous collectons les informations à caractère personnel vous concernant notamment dans les cas
                    suivants et aux fins énumérées ci-dessous :
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    • Création d’un compte client<br/>
                    • Communication avec l’utilisateur<br/>
                    • Questions adressées par le biais du formulaire de contact ou dans le cadre d’échanges pour des
                    services de support (y compris avec un <em>chatbot</em>)<br/>
                    • Données téléchargées dans votre compte d’utilisateur<br/>
                    • Vérification de votre identité<br/>
                    • Création de statistiques d’utilisation<br/>
                    • Marketing et études de marché
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Les finalités et objectifs de la collecte de données personnelles servent, en particulier, nos
                    intérêts et potentiellement ceux de tiers dans le cadre de l’exécution de certaines prestations.
                    Nous traitons ainsi vos données à des fins :
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    • de communication avec vous, notamment pour répondre à vos demandes et à l'exercice de vos
                    droits et pour nous permettre de vous contacter en cas de questions. À cette fin, nous utilisons
                    notamment les données de communication et les données de base, ainsi que les données
                    d'enregistrement en rapport avec les offres et services que vous utilisez. Nous pouvons conserver
                    ces données pour documenter les communications avec vous à des fins de formation, d'assurance
                    qualité et/ou de suivi des demandes.<br/>
                    • de conclusion, de l'administration et l'exécution des relations contractuelles.<br/>
                    • de marketing et de gestion des relations.<br/>
                    • d'études de marché, pour améliorer nos services et nos activités commerciales, et pour
                    le développement de produits.<br/>
                    • de sécurité et de contrôle d'accès.<br/>
                    • Nous traitons les données personnelles pour nous conformer aux lois, directives et recommandations
                    des autorités et aux règlements internes (« respect des exigences légales »).<br/>
                    • Nous traitons également les données dans le cadre de notre gestion des risques et de gouvernance
                    d'entreprise, y compris l'organisation et le développement des affaires.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Nous pouvons traiter vos données à d'autres fins, par exemple dans le cadre de nos processus
                    internes et de notre administration ou à des fins d'assurance qualité et de formation.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Lorsque nous demandons votre consentement pour certaines activités de traitement (par exemple pour
                    les activités de marketing, pour l'inscription au portail de gestion des fournisseurs, pour la
                    gestion de la publicité et l'analyse des comportements sur le site web), nous vous informons
                    séparément des objectifs de traitement concernés. Vous pouvez retirer votre consentement à tout
                    moment avec effet pour l'avenir en nous envoyant un e-mail à l’adresse électronique suivante : <a
                    href="mailto:info@amp-it.ch">info@amp-it.ch</a> . Dès que nous avons reçu la notification du retrait
                    du consentement, nous ne traiterons plus vos informations pour la ou les finalités auxquelles vous
                    avez consenti, à moins que nous ayons une autre base juridique pour le faire. Le retrait du
                    consentement n'affecte toutefois pas la légalité du traitement fondé sur le consentement antérieur
                    au retrait.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Lorsque nous ne demandons pas le consentement pour le traitement, le traitement de vos données
                    personnelles repose sur la nécessité du traitement pour initier ou exécuter un contrat avec vous (ou
                    l'entité que vous représentez) ou sur notre intérêt légitime ou celui d'un tiers dans le traitement
                    en question, en particulier dans la poursuite des finalités et des objectifs énoncés dans la
                    présente politique de confidentialité et dans la mise en œuvre de mesures y relatives. Nos intérêts
                    légitimes comprennent également le respect des réglementations légales, dans la mesure où cela n'est
                    pas déjà reconnu comme une base juridique par la législation applicable en matière de protection des
                    données (par exemple, dans le cas du RGPD, les lois dans l'EEE et, dans le cas de la LPD, le droit
                    suisse). Cela inclut également la commercialisation de nos services, la volonté de mieux comprendre
                    nos marchés et de gérer et développer notre entreprise, y compris ses activités, de manière sûre et
                    efficace.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    2.2 Partage de données
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Dans le cadre de nos contrats, de l’utilisation du site internet, de nos services, de nos
                    obligations légales, de la protection de nos intérêts légitimes et des autres finalités énoncées
                    ci-dessus, nous pouvons communiquer vos données personnelles à des tiers, notamment aux catégories
                    de destinataires suivantes :
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    • <strong>Prestataires de services</strong> : Nous travaillons avec des prestataires de services en
                    Suisse et à l'étranger qui traitent vos données en notre nom ou en tant que responsables conjoints
                    du traitement avec nous ou qui reçoivent des données vous concernant de notre part en tant que
                    responsables indépendants du traitement (par exemple des prestataires informatiques, des
                    prestataires de services publicitaires, des sociétés de sécurité informatique, des banques, des
                    compagnies d'assurance, des sociétés de recouvrement de créances, des agences d'information sur le
                    crédit ou des prestataires de vérification d'adresse, d’identité et/ou de signature).<br/>
                    • Partenaires contractuels, y compris les clients : Il s'agit des clients (par exemple les
                    bénéficiaires de services) et nos autres partenaires contractuels, dans la mesure où la
                    communication des données découle de ces contrats. Par exemple, ils reçoivent des données
                    d'enregistrement en rapport avec la fourniture de produits et services, etc. Si vous travaillez pour
                    l'un de ces partenaires contractuels, nous pouvons également leur communiquer des données vous
                    concernant. Parmi ces destinataires figurent également les partenaires contractuels avec lesquels
                    nous coopérons ou qui effectuent de la publicité pour nous ou d'autres services en notre nom et à
                    qui nous pouvons donc communiquer des données vous concernant à des fins d'analyse,
                    d'approvisionnement et de marketing.<br/>
                    • Autorités : Nous pouvons communiquer des données personnelles à des agences, des tribunaux,
                    autorité arbitrale et d'autres autorités en Suisse et à l'étranger si nous sommes légalement obligés
                    ou habilités à faire de telles communications ou si cela semble nécessaire pour protéger nos
                    intérêts. Ces autorités agissent en tant que responsables indépendants du traitement.<br/>
                    • Autres personnes : Il s'agit d'autres cas où les interactions avec des tiers s'inscrivent dans le
                    cadre des objectifs énoncés ci-dessus, par exemple les bénéficiaires de services, les médias et les
                    associations auxquels nous participons, ou si vous figurez dans l'une de nos publications.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    En outre, nous permettons à certains tiers de collecter vos données personnelles sur notre site web
                    et lors d'événements que nous organisons (par exemple, les fournisseurs d'outils sur notre site web,
                    etc.). Lorsque nous n'avons aucun contrôle sur ces collectes de données, ces tiers sont des
                    responsables indépendants du traitement. Si vous avez des questions ou souhaitez exercer vos droits
                    en matière de protection des données, nous vous invitons à contacter ces tiers directement.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    2.2.1 Visite du site internet
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Lorsque vous consultez notre site internet, nos serveurs stockent temporairement les données
                    suivantes dans ce qu’on appelle un fichier journal de serveur. Ces données sont supprimées dès
                    qu’elles ne sont plus nécessaires à l’objectif de la collecte.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    • Adresse IP de l’ordinateur à l’origine de la demande<br/>
                    • Date et heure de l’accès ou de la récupération<br/>
                    • URL des données récupérées<br/>
                    • Système d’exploitation, modèle de votre ordinateur et type de navigateur que vous utilisez<br/>
                    • Pays à partir duquel vous accédez à notre site internet<br/>
                    • Nom de votre fournisseur d’accès internet<br/>
                    • Décalage horaire avec l’heure de Greenwich (GMT)<br/>
                    • Statut d’accès, code de statut HTTP<br/>
                    • Quantité de données transférées<br/>
                    • Dernier site internet consulté<br/>
                    • Paramètres du navigateur<br/>
                    • Langue et version de votre logiciel de navigation
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    La base juridique pour le stockage temporaire des données à caractère personnel et des fichiers
                    journaux est l’intérêt légitime et l’exécution d’une relation contractuelle. Il est dans notre
                    intérêt légitime
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    • de présenter correctement le contenu de notre site internet<br/>
                    • d’optimiser le contenu de notre site internet et de le promouvoir<br/>
                    • de fournir aux autorités les informations nécessaires pour engager des poursuites en cas de
                    cyberattaque<br/>
                    • d’améliorer en permanence notre offre et notre site internet<br/>
                    • de collecter des données statistiques
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Nous utilisons les données vous concernant essentiellement pour améliorer votre expérience en tant
                    que client et la rendre plus conviviale, communiquer avec vous relativement à vos questions ou
                    sollicitations, vous fournir des informations sur des services spécifiques ou des campagnes
                    marketing, et vous recommander des produits ou des services susceptibles de vous intéresser.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    2.2.2 Bulletin d’information
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Vous pouvez vous inscrire à notre bulletin d’information. Pour le recevoir, vous devez avoir créé un
                    compte sur notre site internet ou notre application. Votre consentement constitue la base juridique
                    du traitement des données une fois que vous vous êtes inscrit au bulletin d’information.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Lorsque vous nous fournissez les données vous concernant, vous nous autorisez à utiliser le bulletin
                    d’information pour vous envoyer des informations concernant, par exemple, les services, promotions
                    événements et nouveautés.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    En outre, les données suivantes sont collectées au moment de l’inscription :
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    • Adresse IP de l’ordinateur à l’origine de la requête<br/>
                    • Date et heure de l’inscription<br/>
                    • Origine de l’inscription (ex : site internet, liste d’attente)
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Ces données sont nécessaires à l'envoi des bulletins d'information et sont traitées sur la base de
                    votre consentement. À tout moment, vous pouvez vous désinscrire du bulletin d’information et
                    révoquer votre consentement. Vous trouverez également dans chaque bulletin d’information un lien
                    vers la page de désinscription. Nous conservons les données vous concernant jusqu’à votre
                    désinscription du bulletin d’information.<br/>
                    <br/>
                    <strong>2.2.3 Services proposés</strong><br/>
                    <br/>
                    <strong>2.2.3.1 Généralités</strong>
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Si vous souhaitez utiliser nos services, il est impératif que vous nous fournissiez les données
                    nécessaires au traitement de votre demande.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Nous conservons les données vous concernant dans le cadre de nos obligations contractuelles et les
                    supprimons dès que nous ne sommes légalement plus tenus de les conserver. Dans le cadre du
                    traitement de votre dossier, les prestataires de services auxquels nous recourons (tels que des
                    banques, entreprises informatique et fournisseurs de services de paiement) se voient communiquer les
                    données nécessaires audit traitement. Ces données peuvent notamment comprendre votre adresse e-mail
                    et votre numéro de téléphone, ce qui permet par exemple de vous contacter pour résoudre d’éventuels
                    problèmes.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    2.2.3.2 Création d’un compte utilisateur
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    En créant votre compte client, dont l’accès est sécurisé par un mot de passe, vous pouvez consulter
                    l’information et les données que vous avez stockées.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Pour créer un compte client, les informations suivantes peuvent notamment être recueillies, en
                    fonction des cas :
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    • Adresse e-mail<br/>
                    • Mot de passe<br/>
                    • Civilité<br/>
                    • Prénom<br/>
                    • Nom de famille<br/>
                    • Numéro de téléphone<br/>
                    • Adresse de domicile<br/>
                    • Adresse de parking
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Lorsqu’un utilisateur supprime son compte, les données liées audit compte peuvent être supprimées,
                    sous réserve des exigences de conservation imposées par la législation. Si vous décidez de supprimer
                    votre compte, il vous incombe au préalable de sauvegarder les données vous concernant. Nous sommes
                    habilités à effacer de façon irrévocable toutes les données conservées pendant la période d’activité
                    du compte utilisateur.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    2.2.3.3 Assistant virtuel (chatbot) et intelligence artificielle
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    AMP IT met à disposition de ses utilisateurs un assistant virtuel reposant sur une intelligence
                    artificielle afin de répondre aux demandes de support relatives à ses services. L’assistant indique,
                    au début de chaque conversation, qu’il s’agit d’un système automatisé, et vous pouvez à tout moment
                    demander à être orienté vers un collaborateur. Le recours à l’assistant n’est pas obligatoire.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    À votre demande, l'assistant peut également exécuter certaines opérations sur votre compte, telles
                    que la gestion des programmations de recharge ou l'envoi de commandes à une borne. Ces opérations ne
                    sont jamais exécutées automatiquement : elles vous sont présentées et ne sont effectuées qu'après
                    votre confirmation explicite, dans les limites de vos droits d'accès.Les données traitées dans ce
                    cadre sont celles que vous communiquez lors de la conversation ainsi que, selon vos droits d’accès,
                    certaines données techniques nécessaires au traitement de votre demande. Elles sont utilisées afin
                    de fournir le support sollicité, d’en assurer le suivi et d’en contrôler la qualité.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    L’assistant repose sur un modèle d’intelligence artificielle fourni par Anthropic (entité
                    contractante pour la Suisse et l’Union européenne : Anthropic Ireland, Limited), exploité au moyen
                    de l’infrastructure d’Amazon Web Services. Les requêtes sont traitées au sein de centres de données
                    situés en Suisse et dans l’Union européenne, à l’exclusion de tout acheminement vers des régions
                    situées en dehors de ce périmètre. Chaque utilisateur est invité à consulter les informations et
                    politiques de confidentialité relatives aux services proposés par Amazon Web Services (voir
                    notamment <a
                    href="https://aws.amazon.com/fr/compliance/gdpr-center/">https://aws.amazon.com/fr/compliance/gdpr-center/</a>)
                    et par Anthropic Ireland, Limited (voir notamment <a
                    href="https://www.anthropic.com/legal/privacy">https://www.anthropic.com/legal/privacy</a> )<strong>.</strong> Les
                    conversations sont conservées dans les bases de données propres d’AMP IT et ne sont accessibles ni à
                    Amazon Web Services, ni à Anthropic sous réserve des exceptions applicables. Elles ne sont pas
                    utilisées pour entraîner des modèles d’intelligence artificielle. Elles sont conservées pour la
                    durée nécessaire aux finalités décrites ci-dessus et vous pouvez supprimer vos conversations en tout
                    temps depuis votre compte.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    <br/>
                    3. Suppression
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Nous ne traitons et stockons les données à caractère personnel vous concernant que pour la durée
                    nécessaire à la réalisation de l’objectif de la collecte, ou conformément à la législation ou la
                    réglementation à laquelle nous sommes assujettis. Lorsque l’objectif du stockage cesse d’exister, ou
                    lorsqu’une période de conservation prescrite expire, les données à caractère personnel sont
                    habituellement bloquées ou supprimées. Nous supprimons en outre les données vous concernant si vous
                    en faites la demande en nous envoyant un e-mail à l’adresse : <a
                    href="mailto:info@amp-it.ch">info@amp-it.ch</a> , et si aucune obligation légale ou autre ne nous
                    enjoint de conserver ou sauvegarder lesdites données.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    En cas de suppression des données personnelles enregistrées volontairement sur votre compte
                    personnel, seules des données anonymisées demeureront stockées après la suppression des données à
                    caractère personnel.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    <br/>
                    4 Divulgation à des tiers
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    4.1 Principes
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Nous ne transmettons les données vous concernant que si vous y avez formellement consenti, si la
                    législation l’exige, ou si cette divulgation relève de l’utilisation de nos services, de la réponse
                    aux questions, du traitement des demandes ou d’éventuels services que vous avez requis.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Tous les destinataires ne sont pas situés en Suisse. Vos données peuvent donc être traitées à la
                    fois en Europe et en principe dans n'importe quel pays dans le monde. Si un destinataire est situé
                    dans un pays sans protection légale adéquate des données, nous exigeons que le destinataire s'engage
                    à respecter la législation applicable en matière de protection des données, à moins que le
                    destinataire ne soit déjà soumis à un ensemble de règles légalement acceptées visant à garantir la
                    protection des données ou que nous ne puissions invoquer une exception. Une exception s'applique,
                    par exemple, dans le cas d'une procédure judiciaire à l'étranger, dans le cas d'un intérêt public
                    prépondérant ou lorsque l'exécution d'un contrat exige la communication de données, de même que si
                    vous avez consenti au transfert des données ou si les données ont été mises à disposition de manière
                    générale par vous directement et que vous ne vous êtes pas opposé au traitement. Veuillez noter que
                    les données échangées via Internet transitent souvent par des pays tiers. Vos données peuvent donc
                    être envoyées à l'étranger même si l'expéditeur et le destinataire se trouvent dans le même pays.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Nous communiquons vos informations à caractère personnel aux catégories de destinataires suivantes :
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    • Les prestataires de service<br/>
                    • Les partenaires commerciaux<br/>
                    • Les entreprises partenaires de contrôle d’identité<br/>
                    • Les partenaires logistiques<br/>
                    • Les hébergeurs partenaires<br/>
                    • Les autorités et assurances sociales (que ce soit des institutions publiques ou privées)
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Lorsque nous faisons appel à des sous-traitants pour assurer nos services, nous nous engageons à
                    prendre toutes les précautions requises par la législation, ainsi que les mesures de sécurité
                    techniques et organisationnelles correspondantes, pour garantir que les données à caractère
                    personnel vous concernant soient protégées conformément aux dispositions réglementaires pertinentes.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    4.2 Compte personnel
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Vous êtes informé que les données que vous stockez sur une base volontaire dans votre compte
                    personnel sont hébergés sur AWS. Si vous souhaitez avoir plus d’information relatif à l’hébergement
                    de vos données auprès AWS et à sa politique de confidentialité, n’hésitez pas à consulter le lien
                    suivant : <a
                    href="https://aws.amazon.com/fr/compliance/data-protection/">https://aws.amazon.com/fr/compliance/data-protection/</a>
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    4.3 Recours à des services spécifiques
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    AMP IT recourt à certains prestataires/applications dans le cadre de l’automatisation de ses
                    processus et de la gestion des comptes d’utilisateurs . Vous êtes informé que des données
                    personnelles peuvent être partagées avec ces prestataires de service pour l’exécution des services
                    de AMP IT en votre faveur. Vous pouvez à n’importe quel moment demander plus d’information à AMP IT
                    concernant les services spécifiques et consulter les politiques de confidentialité des prestataires.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    À ce jour, ces prestataires comprennent : Amazon Web Services (hébergement et infrastructure),
                    Anthropic (modèle d’intelligence artificielle de l’assistant virtuel), Stripe (traitement des
                    paiements), Bexio (comptabilité et facturation), Freshsales (gestion de la relation client) et
                    Google (mesure d'audience du site internet, ainsi que services Firebase de l'application mobile :
                    notifications push, statistiques d'utilisation et rapports d'incident). Le recours à ces
                    prestataires est limité à ce qui est nécessaire à la fourniture des services concernés. Vous êtes
                    invité à consulter leurs politiques de confidentialité.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    <br/>
                    5. Données analytiques
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Sur la base de votre consentement, et par le biais de la technique des cookies, des données sont
                    collectées aux fins d’optimiser nos services et l’expérience utilisateur. Ces données sont
                    analytiques et ne sont pas utilisées pour vous identifier personnellement, mais servent uniquement à
                    une évaluation sous pseudonyme de l’utilisation des services. Les données vous concernant ne sont
                    jamais fusionnées avec les données à caractère personnel que nous conservons.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    <br/>
                    6. Cookies<br/>
                    6.1 Que sont les cookies ?
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Notre site internet utilise ce qu’on appelle des cookies. Les cookies sont des informations
                    transmises par notre serveur internet ou par des serveurs internet tiers aux navigateurs internet
                    des utilisateurs. Celles-ci sont alors stockées dans ces navigateurs avant d’être extraites
                    ultérieurement. Ils peuvent prendre la forme de petits fichiers ou d’autres supports de stockage
                    d’informations.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    6.2 Pourquoi utilisons-nous des cookies ?
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Les cookies servent à optimiser les informations et offres affichées sur notre site internet afin
                    d’améliorer votre expérience. Ils nous permettent de reconnaître les visiteurs de notre site
                    internet. Grâce à cette reconnaissance, votre utilisation de notre site internet est facilitée. Les
                    cookies strictement nécessaires au fonctionnement du site sont déposés sur la base de notre intérêt
                    légitime. Les cookies de mesure d'audience décrits au chiffre 7 ne sont déposés qu'avec votre
                    consentement.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    6.3 Quels cookies utilisons-nous ?
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Le site internet utilise les cookies suivants :
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    • Témoins volatils<br/>
                    • Cookies permanents<br/>
                    • Cookies anonymes<br/>
                    • Cookies de préférence<br/>
                    • Cookies de performance<br/>
                    • Cookies tiers
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Les cookies temporaires sont automatiquement supprimés dès que vous fermez le navigateur. Il s’agit
                    notamment des témoins volatils. Ceux-ci stockent ce que l’on appelle un identifiant de session,
                    grâce auquel diverses requêtes provenant de votre navigateur peuvent être associées à la session
                    correspondante. Ils permettent à votre ordinateur d’être reconnu lorsque vous retournez sur le site
                    internet. Nous utilisons ce type de cookies pour assurer le fonctionnement correct de notre site
                    internet.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Les cookies permanents, quant à eux, sont conservés sur votre disque dur même après la fin de la
                    session. Ces cookies nous permettent notamment de rendre notre offre plus conviviale, par exemple en
                    mémorisant vos préférences d'affichage.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Les cookies anonymes, comme les cookies statistiques, ne nous communiquent pas de données à
                    caractère personnel. Ils collectent et restituent les informations de manière anonyme, et nous
                    permettent de comprendre comment les visiteurs interagissent avec les pages internet. Les cookies de
                    préférence mémorisent les paramètres de comportement ou d’affichage d’une page internet, votre
                    langue préférée ou la région dans laquelle vous vous trouvez par exemple.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Quant aux cookies de performance, ils nous servent à rassembler des informations sur la façon dont
                    vous utilisez nos services, ce qui nous permet de les améliorer. Nous les utilisons par exemple pour
                    déterminer si vous avez affiché une page en particulier.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    <br/>
                    6.4 Gestion et refus des cookies
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Lors de votre première visite, une bannière vous permet d'accepter ou de refuser les cookies qui ne
                    sont pas strictement nécessaires au fonctionnement du site. Tant que vous n'avez pas donné votre
                    accord, aucun cookie de mesure d'audience n'est déposé et aucune donnée n'est transmise à ce titre.
                    Vous pouvez modifier ou retirer votre choix en tout temps, avec effet pour l'avenir, en utilisant
                    cette bannière ou en supprimant les cookies et les données de site enregistrés par votre navigateur.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Il n’est pas obligatoire d’accepter les cookies pour consulter nos sites internet. La plupart des
                    navigateurs acceptent automatiquement les cookies. Si vous ne souhaitez pas les autoriser, vous
                    pouvez paramétrer votre navigateur de manière à afficher les différentes options de paramétrage des
                    cookies, et d’y consentir que dans certains cas. Vous pouvez également le paramétrer de façon à ne
                    stocker aucun cookie sur votre ordinateur, ou à recevoir une alerte chaque fois qu’un nouveau cookie
                    est produit. Certains navigateurs autorisent par exemple les cookies du site visité, mais bloquent
                    les cookies tiers.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    De plus, les cookies qui sont déjà installés sur votre appareil peuvent être supprimés à tout moment
                    depuis votre navigateur ou d’autres programmes informatiques. Tous les navigateurs internet
                    classiques proposent cette option. Vous pouvez régler votre navigateur pour refuser de façon
                    permanente tous les cookies.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    <br/>
                    7. Outils d’analyse internet<br/>
                    <br/>
                    7.1 Principes
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Notre site internet utilise Google Analytics, dont les modalités sont décrites ci-après. Cet outil
                    n'est activé qu'après votre consentement.. :
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    7.2 Google Analytics
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Sur la base de votre consentement, nous avons recours à Google Analytics 4, un service d'analyse
                    d'audience fourni, pour les utilisateurs situés en Suisse et dans l'Espace économique européen, par
                    Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irlande (« Google »). Aucun cookie de
                    mesure d'audience n'est déposé et aucune donnée n'est transmise à Google avant que vous n'ayez
                    accepté les cookies correspondants ; nous recourons à cet effet au mécanisme de gestion du
                    consentement de Google (Consent Mode v2), dont les paramètres par défaut refusent la mesure
                    d'audience et la publicité. Vous pouvez retirer votre consentement en tout temps, avec effet pour
                    l'avenir, en modifiant votre choix dans la bannière de cookies de notre site ou en supprimant les
                    cookies et les données de site enregistrés par votre navigateur (ch. 6.4).
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Google utilise des cookies. Google traite les informations ainsi collectées pour notre compte, aux
                    fins d'évaluer votre utilisation de notre offre en ligne, de compiler des rapports en lien avec les
                    activités de celle-ci et de mettre à notre disposition d'autres services qui y sont liés. Dans ce
                    contexte, des profils d'utilisateur pseudonymes sont susceptibles d'être créés à partir des données
                    traitées. Ces profils d'utilisateur sont automatiquement supprimés à l'échéance de la durée de
                    conservation configurée dans notre propriété Google Analytics, soit au maximum quatorze mois.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Google Analytics 4 n'enregistre ni ne conserve les adresses IP. Pour le trafic provenant de Suisse,
                    de l'Espace économique européen et du Royaume-Uni, la recherche de géolocalisation est effectuée sur
                    des serveurs situés dans ces mêmes régions, l'adresse IP étant supprimée avant tout enregistrement ;
                    seules des données de géolocalisation approximatives (pays, région, ville) en sont dérivées.
                    L'adresse IP transmise par le navigateur de l'utilisateur n'est fusionnée avec aucune autre donnée
                    fournie par Google.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Certaines données peuvent être transférées à Google LLC aux États-Unis, où elles sont stockées. Ces
                    transferts reposent sur la décision d'adéquation du Conseil fédéral relative au Swiss–U.S. Data
                    Privacy Framework, en vigueur depuis le 15 septembre 2024, ainsi que, pour les personnes concernées
                    dans l'Union européenne, sur la décision d'adéquation de la Commission européenne du 10 juillet 2023
                    relative à l'EU–U.S. Data Privacy Framework, Google LLC étant certifiée au titre de ces cadres. À
                    titre subsidiaire, ces transferts reposent sur les clauses contractuelles types de la Commission
                    européenne.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Vous pouvez en outre bloquer la collecte des données générées par les cookies et liées à votre
                    utilisation de notre offre en ligne, ainsi que le traitement de ces données par Google, en cliquant
                    sur le lien ci-dessous. Téléchargez et installez l’extension dans votre navigateur : <a
                    href="http://tools.google.com/dlpage/gaoptout?hl=en">http://tools.google.com/dlpage/gaoptout?hl=en</a>.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    . Pour en savoir plus sur la façon dont Google utilise vos données ainsi que sur les paramètres
                    disponibles, veuillez consulter les sites internet Google suivants :
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    <a
                    href="https://www.google.com/intl/en/policies/privacy/partners">https://www.google.com/intl/en/policies/privacy/partners</a> (traitement
                    des données par Google quand vous utilisez des sites internet ou nos partenaires d’applications),
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    <a
                    href="http://www.google.com/policies/technologies/ads">http://www.google.com/policies/technologies/ads</a> (utilisation
                    des données à des fins publicitaires),
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    <a href="http://www.google.com/settings/ads">http://www.google.com/settings/ads</a> (gestion des
                    informations que Google utilise pour afficher des annonces à votre intention).
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    <br/>
                    8. Vos droits
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Voici vos droits relatifs aux données vous concernant : accès aux informations relatives aux données
                    conservées, rectification, suppression, limitation, transfert, refus et révocation. Si vous pensez
                    que le traitement des données vous concernant enfreint la législation en matière de protection des
                    données ou que vos droits en la matière n’ont pas été respectés, vous pouvez adresser une plainte à
                    l’autorité de contrôle. Si vous êtes situé dans l'EEE ou en Suisse, vous avez également le droit de
                    déposer une plainte auprès de l'autorité de surveillance de la protection des données compétente
                    dans votre pays. Vous trouverez une liste des autorités dans l'EEE ici : <a
                    href="https://edpb.europa.eu/about-edpb/board/members_en">https://edpb.europa.eu/about-edpb/board/members_en</a> .
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Vous pouvez joindre l'autorité de contrôle suisse à l'adresse suivante : https://<a
                    href="https://www.edoeb.admin.ch/edoeb/fr/home/le-pfpdt/contact.html">www.edoeb.admin.ch/edoeb/fr/home/le-pfpdt/contact.html</a>.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Les lois applicables en matière de protection des données vous donnent le droit de vous opposer au
                    traitement de vos données dans certaines circonstances, notamment le traitement à des fins de
                    marketing direct, le profilage à des fins de marketing direct et d'autres intérêts légitimes dans le
                    traitement.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Pour vous aider à contrôler le traitement de vos données personnelles, vous disposez des droits
                    suivants en ce qui concerne notre traitement de vos données, conformément à la législation
                    applicable en matière de protection des données :
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    • Le droit de nous demander des informations pour savoir si nous traitons des données vous
                    concernant et, le cas échéant, lesquelles ;<br/>
                    • Le droit de demander que nous corrigions les données si elles sont inexactes ;<br/>
                    • Le droit de demander l'effacement des données ;<br/>
                    • Le droit de demander que nous fournissions certaines données personnelles dans un format
                    électronique couramment utilisé ou que nous les transférions à un autre responsable du traitement
                    ;<br/>
                    • Le droit de retirer votre consentement, lorsque notre traitement est basé sur votre consentement
                    ;<br/>
                    • Le droit de recevoir, sur demande, d'autres informations utiles à l'exercice de ces droits.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Si vous souhaitez exercer les droits susmentionnés envers nous, vous pouvez nous contacter par écrit
                    à notre adresse ou, sauf indication ou accord contraire, par e-mail. Afin de pouvoir prévenir tout
                    abus, nous devons vous identifier (par exemple au moyen d'une copie de votre carte d'identité, si
                    l'identification n'est pas possible autrement).
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Vous disposez également de ces droits envers les autres parties qui coopèrent avec nous en tant que
                    responsables indépendants du traitement – vous pouvez les contacter directement si vous souhaitez
                    exercer vos droits en relation avec leur traitement de vos données. Vous trouverez des informations
                    sur nos principaux partenaires et prestataires de services plus haut.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Veuillez noter que des conditions, exceptions et restrictions peuvent s'appliquer dans le cadre de
                    l'exercice de ces droits conformément à la législation applicable en matière de protection des
                    données (par exemple pour protéger des tiers ou des secrets commerciaux). Le cas échéant, nous vous
                    en informerons.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Pour toute question, suggestion ou demande, veuillez nous contacter à l’adresse : <a
                    href="mailto:info@amp-it.ch">info@amp-it.ch</a> .
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Veuillez noter que la législation exige que certaines données soient conservées pendant une période
                    spécifique. Nous avons, par conséquent, l’obligation de conserver lesdites données jusqu’à
                    l’expiration de ladite période. Nous verrouillons lesdites données dans nos systèmes informatiques
                    et les utilisons uniquement pour satisfaire aux exigences de la législation.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    <br/>
                    9. Utilisation du site internet par les mineurs
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Les services proposés s’adressent à un public adulte. Il est interdit aux mineurs de nous
                    communiquer des informations permettant de les identifier, ou de se connecter pour utiliser nos
                    services. Si nous remarquons la présence d’informations de ce type dans nos bases de données, nous
                    les supprimerons immédiatement. Le père, la mère ou le représentant légal de l’enfant est habilité à
                    nous contacter pour demander la suppression des données ou du compte utilisateur créé. Dans ce cas,
                    la personne qui effectue la demande doit nous fournir un justificatif officiel de son statut de
                    parent ou de représentant légal.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    <br/>
                    10. Sécurité des données
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Nous prenons toutes les précautions nécessaires en matière technique et organisationnelle pour
                    protéger les données à caractère personnel vous concernant contre la falsification, la perte, la
                    destruction ou l’accès par des personnes non autorisées, pour garantir vos droits et nous conformer
                    à la législation en vigueur en matière de protection des données.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Les mesures prises visent à garantir la confidentialité et l’intégrité des données vous concernant,
                    ainsi que la disponibilité et la stabilité à long terme de nos systèmes et services dans le cadre du
                    traitement desdites données. Elles garantissent également la restauration rapide de la disponibilité
                    des données et de l’accès à celles-ci dans l’éventualité d’un incident matériel ou technique. Nos
                    mesures en matière de traitement des données et de sécurité sont constamment améliorées au rythme
                    des progrès de la technologie.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    Nous prenons également très au sérieux la protection des données confidentielles de notre propre
                    entreprise. Nos employés, ainsi que les prestataires de services que nous employons, ont une
                    obligation de confidentialité et sont tenus de se conformer à la réglementation en matière de
                    protection des données. Ils n’ont en outre accès aux données à caractère personnel que dans la
                    mesure nécessaire à leur activité.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyFrenchSx.paragraph}
                >
                    <br/>
                    11. Modifications de la politique de confidentialité
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyFrenchSx.paragraph}
                >
                    AMP IT peut à tout moment modifier la présente politique de confidentialité. Ces modifications
                    relèvent de l'entière discrétion d'AMP IT. La version en vigueur est celle publiée sur notre site
                    internet et dans nos applications ; elle porte la date figurant en tête du présent document.
                </Typography>
            </Box>
        </Box>
    );
};